module.exports = [
	{
		"event": "Women's synchronized 3m springboard",
		"event_key": "event1",
		"date": "Aug 7, 2016",
		"country": "Italy",
		"athletes": [
			"T. Cagnotto",
			"F. Dallapé"
		],
		"total": 313.83,
		"gender": "W",
		"medal": "silver",
		"breakdown": [
			[
				2,
				51.6,
				[
					8.5,
					8.5,
					8,
					8.5,
					8.5,
					8.5
				],
				[
					9,
					8.5,
					9,
					5.5,
					8.5
				],
				"Back Dive"
			],
			[
				2,
				50.4,
				[
					8,
					8,
					8.5,
					8.5,
					8.5,
					9
				],
				[
					8.5,
					8.5,
					8.5,
					8,
					8.5
				],
				"Reverse Dive"
			],
			[
				3,
				71.1,
				[
					7.5,
					7.5,
					8,
					8,
					8,
					8
				],
				[
					8,
					7.5,
					8,
					8.5,
					8
				],
				"Forward 2½ Somersault 1 Twist"
			],
			[
				3.1,
				66.03,
				[
					8,
					7.5,
					7.5,
					6.5,
					7,
					7
				],
				[
					7,
					7,
					7,
					7,
					7.5
				],
				"Forward 3½ Somersaults"
			],
			[
				3,
				74.7,
				[
					8,
					8,
					8,
					7.5,
					8,
					8
				],
				[
					8.5,
					8.5,
					8.5,
					8.5,
					8.5
				],
				"Inward 2½ Somersaults"
			]
		]
	},
	{
		"event": "Women's synchronized 3m springboard",
		"event_key": "event1",
		"date": "Aug 7, 2016",
		"country": "China",
		"athletes": [
			"M.X. Wu",
			"T.M. Shi"
		],
		"total": 345.6,
		"gender": "W",
		"medal": "gold",
		"breakdown": [
			[
				2,
				55.8,
				[
					9,
					9.5,
					9,
					8.5,
					9,
					9
				],
				[
					9.5,
					9.5,
					9.5,
					9.5,
					9.5
				],
				"Forward Dive"
			],
			[
				2,
				52.2,
				[
					9,
					9,
					9,
					8.5,
					8.5,
					9
				],
				[
					8.5,
					8.5,
					9,
					8.5,
					9
				],
				"Reverse 1½ Somersault ½ Twist"
			],
			[
				3,
				76.5,
				[
					8.5,
					8.5,
					8,
					8.5,
					7.5,
					8
				],
				[
					9,
					8.5,
					9,
					8.5,
					8.5
				],
				"Inward 2½ Somersaults"
			],
			[
				3,
				80.1,
				[
					9,
					9,
					9,
					8.5,
					9,
					8.5
				],
				[
					8.5,
					9,
					9,
					9,
					9
				],
				"Reverse 2½ Somersaults"
			],
			[
				3,
				81,
				[
					9.5,
					8.5,
					9,
					8.5,
					9,
					9
				],
				[
					9,
					9,
					9,
					9,
					9
				],
				"Back 2½ Somersaults"
			]
		]
	},
	{
		"event": "Women's synchronized 3m springboard",
		"event_key": "event1",
		"date": "Aug 7, 2016",
		"country": "Australia",
		"athletes": [
			"M. Keeney",
			"A. Smith"
		],
		"total": 299.19,
		"gender": "W",
		"medal": "bronze",
		"breakdown": [
			[
				2,
				48,
				[
					8,
					8,
					8,
					7.5,
					7.5,
					8
				],
				[
					8,
					8.5,
					8,
					8.5,
					8
				],
				"Back Dive"
			],
			[
				2,
				42,
				[
					7,
					7.5,
					7.5,
					7,
					6,
					6.5
				],
				[
					8,
					7,
					7,
					7,
					7
				],
				"Reverse Dive"
			],
			[
				3,
				70.2,
				[
					8.5,
					8,
					8,
					7,
					7,
					7
				],
				[
					8,
					8.5,
					8,
					8,
					8
				],
				"Inward 2½ Somersaults"
			],
			[
				3.1,
				67.89,
				[
					7.5,
					8,
					7.5,
					6.5,
					6.5,
					5.5
				],
				[
					7.5,
					7.5,
					7.5,
					8,
					7.5
				],
				"Forward 3½ Somersaults"
			],
			[
				3,
				71.1,
				[
					7.5,
					8,
					7.5,
					7.5,
					7.5,
					7.5
				],
				[
					8,
					7.5,
					8,
					8.5,
					8.5
				],
				"Forward 2½ Somersault 1 Twist"
			]
		]
	},
	{
		"event": "Men's synchronized 10m platform",
		"event_key": "event2",
		"date": "Aug 8, 2016",
		"country": "United States",
		"athletes": [
			"S. Johnson",
			"D. Boudia"
		],
		"total": 457.11,
		"gender": "M",
		"medal": "silver",
		"breakdown": [
			[
				2,
				54,
				[
					9,
					9,
					9,
					9,
					9.5,
					9
				],
				[
					9,
					9,
					9,
					9,
					9.5
				],
				"Forward Dive"
			],
			[
				2,
				53.4,
				[
					9,
					8.5,
					9,
					8.5,
					9,
					9
				],
				[
					9,
					9,
					8.5,
					8.5,
					9
				],
				"Back Dive"
			],
			[
				3.2,
				83.52,
				[
					8.5,
					8.5,
					8.5,
					8.5,
					9,
					8.5
				],
				[
					8.5,
					8.5,
					9,
					9,
					9
				],
				"Inward 3½ Somersaults"
			],
			[
				3.4,
				85.68,
				[
					7.5,
					7,
					7.5,
					9,
					9.5,
					9
				],
				[
					8,
					8.5,
					8.5,
					8.5,
					8.5
				],
				"Reverse 3½ Somersaults"
			],
			[
				3.7,
				85.47,
				[
					7,
					7,
					7.5,
					8,
					7.5,
					7.5
				],
				[
					8.5,
					8,
					8,
					8,
					7.5
				],
				"Forward 4½ Somersault"
			],
			[
				3.6,
				95.04,
				[
					8,
					9,
					8.5,
					8.5,
					8.5,
					8.5
				],
				[
					9,
					9,
					9,
					9,
					9
				],
				"Back 2½ Somersault 2½ Twists"
			]
		]
	},
	{
		"event": "Men's synchronized 10m platform",
		"event_key": "event2",
		"date": "Aug 8, 2016",
		"country": "China",
		"athletes": [
			"A. Chen",
			"Y. Lin"
		],
		"total": 496.98,
		"gender": "M",
		"medal": "gold",
		"breakdown": [
			[
				2,
				57,
				[
					9.5,
					9,
					9.5,
					9.5,
					9,
					9.5
				],
				[
					9.5,
					9.5,
					9.5,
					9.5,
					9.5
				],
				"Forward Dive"
			],
			[
				2,
				57,
				[
					9.5,
					9.5,
					9.5,
					9.5,
					9.5,
					9.5
				],
				[
					9.5,
					10,
					9.5,
					9.5,
					9.5
				],
				"Inward Dive"
			],
			[
				3.4,
				92.82,
				[
					8.5,
					8.5,
					9,
					9.5,
					10,
					9
				],
				[
					9.5,
					9,
					9,
					9,
					9.5
				],
				"Reverse 3½ Somersaults"
			],
			[
				3.6,
				85.32,
				[
					7,
					7,
					6.5,
					8,
					8.5,
					8.5
				],
				[
					8,
					8,
					8,
					8,
					8.5
				],
				"Back 3½ Somersaults"
			],
			[
				3.7,
				106.56,
				[
					9.5,
					9.5,
					9,
					9.5,
					10,
					9.5
				],
				[
					9.5,
					9.5,
					9.5,
					10,
					10
				],
				"Forward 4½ Somersault"
			],
			[
				3.6,
				98.28,
				[
					9,
					9,
					9,
					9,
					9,
					9
				],
				[
					8.5,
					9.5,
					9,
					9,
					9.5
				],
				"Back 2½ Somersault 2½ Twists"
			]
		]
	},
	{
		"event": "Men's synchronized 10m platform",
		"event_key": "event2",
		"date": "Aug 8, 2016",
		"country": "Great Britain",
		"athletes": [
			"T. Daley",
			"D. Goodfellow"
		],
		"total": 444.45,
		"gender": "M",
		"medal": "bronze",
		"breakdown": [
			[
				2,
				51.6,
				[
					8.5,
					9,
					9.5,
					8.5,
					8.5,
					8.5
				],
				[
					9,
					8.5,
					8.5,
					8.5,
					8.5
				],
				"Inward 1½ Somersaults"
			],
			[
				2,
				49.8,
				[
					8.5,
					8.5,
					8.5,
					8.5,
					8,
					8.5
				],
				[
					8,
					8,
					8,
					8.5,
					8.5
				],
				"Reverse 1½ Somersault ½ Twist"
			],
			[
				3.2,
				79.68,
				[
					9,
					8.5,
					8.5,
					7.5,
					7.5,
					8
				],
				[
					9,
					8,
					8.5,
					8.5,
					8.5
				],
				"Inward 3½ Somersaults"
			],
			[
				3.4,
				81.6,
				[
					8.5,
					9,
					8.5,
					7.5,
					7.5,
					7.5
				],
				[
					8,
					8.5,
					8,
					7.5,
					8
				],
				"Reverse 3½ Somersaults"
			],
			[
				3.7,
				92.13,
				[
					8,
					8,
					8,
					8,
					8.5,
					8
				],
				[
					9,
					8.5,
					8,
					8.5,
					8.5
				],
				"Forward 4½ Somersault"
			],
			[
				3.6,
				89.64,
				[
					8.5,
					8.5,
					8.5,
					8,
					7.5,
					7.5
				],
				[
					8.5,
					8.5,
					8,
					8.5,
					8.5
				],
				"Back 3½ Somersaults"
			]
		]
	},
	{
		"event": "Women's synchronized 10m platform",
		"event_key": "event3",
		"date": "Aug 9, 2016",
		"country": "Malaysia",
		"athletes": [
			"P. Rinong",
			"J.H. Cheong"
		],
		"total": 344.34,
		"gender": "W",
		"medal": "silver",
		"breakdown": [
			[
				2,
				52.8,
				[
					8.5,
					8.5,
					9,
					8.5,
					9.5,
					8.5
				],
				[
					9,
					9,
					9,
					9.5,
					9
				],
				"Reverse Dive"
			],
			[
				2,
				52.8,
				[
					8.5,
					8.5,
					8.5,
					9,
					8.5,
					8.5
				],
				[
					8.5,
					9,
					9,
					9,
					9
				],
				"Back Dive"
			],
			[
				3,
				76.5,
				[
					6.5,
					8,
					8,
					9,
					8.5,
					8.5
				],
				[
					8.5,
					8,
					8.5,
					9,
					9
				],
				"Forward 3½ Somersaults"
			],
			[
				3.2,
				79.68,
				[
					8,
					7.5,
					8.5,
					8,
					8.5,
					7.5
				],
				[
					8.5,
					8.5,
					8.5,
					9,
					8.5
				],
				"Inward 3½ Somersaults"
			],
			[
				3.2,
				82.56,
				[
					8.5,
					8.5,
					8.5,
					8.5,
					8,
					8.5
				],
				[
					8.5,
					8.5,
					9,
					8.5,
					9
				],
				"Back 2½ Somersault 1½ Twists"
			]
		]
	},
	{
		"event": "Women's synchronized 10m platform",
		"event_key": "event3",
		"date": "Aug 9, 2016",
		"country": "China",
		"athletes": [
			"R. L. Chen",
			"H. X. Liu"
		],
		"total": 354,
		"gender": "W",
		"medal": "gold",
		"breakdown": [
			[
				2,
				55.8,
				[
					9,
					9,
					9,
					9,
					9,
					9
				],
				[
					9.5,
					9.5,
					9.5,
					9.5,
					9.5
				],
				"Back Dive"
			],
			[
				2,
				55.8,
				[
					9,
					8.5,
					9,
					9.5,
					9,
					9
				],
				[
					9.5,
					9.5,
					9.5,
					9.5,
					9.5
				],
				"Reverse Dive"
			],
			[
				3,
				79.2,
				[
					8.5,
					8.5,
					9,
					8.5,
					8.5,
					8.5
				],
				[
					9,
					8.5,
					9,
					9,
					9
				],
				"Forward 3½ Somersaults"
			],
			[
				3.2,
				75.84,
				[
					8,
					7.5,
					7.5,
					7,
					8,
					7.5
				],
				[
					9,
					8,
					8,
					8.5,
					8
				],
				"Inward 3½ Somersaults"
			],
			[
				3.2,
				87.36,
				[
					9.5,
					8.5,
					8.5,
					8.5,
					8.5,
					8.5
				],
				[
					9.5,
					9.5,
					9.5,
					9.5,
					9
				],
				"Back 2½ Somersault 1½ Twists"
			]
		]
	},
	{
		"event": "Women's synchronized 10m platform",
		"event_key": "event3",
		"date": "Aug 9, 2016",
		"country": "Canada",
		"athletes": [
			"M. Benfeito",
			"R. Filion"
		],
		"total": 336.18,
		"gender": "W",
		"medal": "bronze",
		"breakdown": [
			[
				2,
				52.8,
				[
					9,
					8.5,
					8.5,
					8.5,
					9.5,
					8.5
				],
				[
					9,
					9,
					9,
					9,
					9
				],
				"Inward Dive"
			],
			[
				2,
				52.8,
				[
					9,
					8.5,
					8,
					8.5,
					8.5,
					8.5
				],
				[
					9,
					9,
					9,
					9,
					9
				],
				"Reverse Dive"
			],
			[
				3,
				74.7,
				[
					8,
					8,
					8,
					8,
					8,
					8
				],
				[
					9,
					8.5,
					8.5,
					8.5,
					8.5
				],
				"Forward 3½ Somersaults"
			],
			[
				3.3,
				75.24,
				[
					7.5,
					7,
					7,
					7,
					7,
					7.5
				],
				[
					8,
					7.5,
					8,
					8,
					8
				],
				"Back 3½ Somersaults"
			],
			[
				3.2,
				80.64,
				[
					8.5,
					8,
					8,
					8.5,
					8.5,
					8
				],
				[
					8.5,
					8.5,
					8.5,
					8.5,
					9
				],
				"Back 2½ Somersault 1½ Twists"
			]
		]
	},
	{
		"event": "Men's synchronized 3m springboard",
		"event_key": "event4",
		"date": "Aug 10, 2016",
		"country": "United States",
		"athletes": [
			"M. Hixon",
			"S. Dorman"
		],
		"total": 450.21,
		"gender": "M",
		"medal": "silver",
		"breakdown": [
			[
				2,
				50.4,
				[
					8,
					8.5,
					8,
					8.5,
					8.5,
					8.5
				],
				[
					8.5,
					8.5,
					9,
					8.5,
					8.5
				],
				"Back Dive"
			],
			[
				2,
				50.4,
				[
					8.5,
					8.5,
					8.5,
					8.5,
					8.5,
					8
				],
				[
					9,
					8,
					8,
					8.5,
					8.5
				],
				"Reverse Dive"
			],
			[
				3.4,
				85.68,
				[
					8,
					8,
					8,
					9,
					8.5,
					8.5
				],
				[
					8.5,
					8.5,
					8.5,
					8.5,
					8.5
				],
				"Forward 2½ Somersault 2 Twists"
			],
			[
				3.5,
				87.15,
				[
					8.5,
					8,
					8,
					7,
					8,
					8.5
				],
				[
					8.5,
					8.5,
					8.5,
					8.5,
					8
				],
				"Reverse 1½ Somersault 3½ Twists"
			],
			[
				3.4,
				78.54,
				[
					7,
					7.5,
					7.5,
					7.5,
					8,
					6
				],
				[
					7.5,
					8.5,
					7.5,
					8,
					8
				],
				"Inward 3½ Somersaults"
			],
			[
				3.8,
				98.04,
				[
					8.5,
					8,
					8,
					8.5,
					8.5,
					9
				],
				[
					9,
					9,
					8.5,
					8.5,
					9
				],
				"Forward 4½ Somersault"
			]
		]
	},
	{
		"event": "Men's synchronized 3m springboard",
		"event_key": "event4",
		"date": "Aug 10, 2016",
		"country": "Great Britain",
		"athletes": [
			"J. Laugher",
			"C. Mears"
		],
		"total": 454.32,
		"gender": "M",
		"medal": "gold",
		"breakdown": [
			[
				2,
				52.8,
				[
					8,
					8,
					8,
					9,
					9,
					9
				],
				[
					8.5,
					9,
					9,
					9,
					9
				],
				"Back Dive"
			],
			[
				2,
				53.4,
				[
					8,
					8.5,
					8.5,
					8.5,
					9,
					9
				],
				[
					9,
					9,
					8.5,
					9,
					9
				],
				"Reverse Dive"
			],
			[
				3.4,
				84.66,
				[
					7.5,
					8,
					7.5,
					8.5,
					8.5,
					8.5
				],
				[
					8.5,
					8,
					8.5,
					9,
					8.5
				],
				"Forward 2½ Somersault 2 Twists"
			],
			[
				3.4,
				85.68,
				[
					8,
					8,
					8.5,
					8,
					8.5,
					9
				],
				[
					8.5,
					8.5,
					8.5,
					9,
					8
				],
				"Inward 3½ Somersaults"
			],
			[
				3.9,
				86.58,
				[
					7,
					8,
					7.5,
					7.5,
					8,
					8.5
				],
				[
					7.5,
					7,
					7,
					7.5,
					7
				],
				"Forward 2½ Somersault 3 Twists"
			],
			[
				3.8,
				91.2,
				[
					7.5,
					7.5,
					7.5,
					8.5,
					8.5,
					8.5
				],
				[
					8,
					8,
					8,
					8.5,
					8
				],
				"Forward 4½ Somersault"
			]
		]
	},
	{
		"event": "Men's synchronized 3m springboard",
		"event_key": "event4",
		"date": "Aug 10, 2016",
		"country": "China",
		"athletes": [
			"K. Qin",
			"Y. Cao"
		],
		"total": 443.7,
		"gender": "M",
		"medal": "bronze",
		"breakdown": [
			[
				2,
				54,
				[
					9.5,
					9,
					9,
					9,
					9.5,
					9
				],
				[
					9,
					9,
					9,
					9,
					9.5
				],
				"Back Dive"
			],
			[
				2,
				54,
				[
					8.5,
					8.5,
					8.5,
					9,
					8.5,
					9
				],
				[
					9.5,
					9,
					9.5,
					8.5,
					9
				],
				"Forward 1½ Somersaults"
			],
			[
				3.4,
				79.56,
				[
					8.5,
					8,
					8,
					8,
					7.5,
					7.5
				],
				[
					8,
					7.5,
					8,
					8,
					7.5
				],
				"Forward 2½ Somersault 2 Twists"
			],
			[
				3.4,
				82.62,
				[
					9,
					8.5,
					8.5,
					8,
					6.5,
					7
				],
				[
					8.5,
					8,
					8.5,
					8.5,
					8
				],
				"Inward 3½ Somersaults"
			],
			[
				3.5,
				90.3,
				[
					9,
					8.5,
					8.5,
					9.5,
					9,
					9
				],
				[
					8.5,
					8.5,
					8.5,
					9,
					8.5
				],
				"Reverse 3½ Somersaults"
			],
			[
				3.8,
				83.22,
				[
					7,
					7.5,
					7,
					7,
					7,
					7.5
				],
				[
					7.5,
					8,
					7.5,
					7,
					7.5
				],
				"Forward 4½ Somersault"
			]
		]
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/diving.json
 ** module id = 113
 ** module chunks = 0
 **/